import {useSelector} from 'react-redux'
import './index.scss'
import classNames from 'classnames'

const Switch = ({onChange, checked, name, classname, isDisabled}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <label className={classNames('switch', {
            [classname] : !!classname,
            dark: isDarkMode
        })}>
            <input type="checkbox" id={name} name={name} onChange={onChange}
                checked={checked} disabled={isDisabled}/>
            <span className={classNames({
                'slider round': true,
                'off': !checked
            })}/>
        </label>
    )
}

export default Switch
